<ng-container *ngIf="isOrg">
  <div class="col-sm-12 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.OrgName.Visible" />
      {{ 'common.personal-information.org-name' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.OrgName.LabelText"
    />
  </div>
  <div style="clear: both"></div>
</ng-container>

<ng-container *ngIf="!isOrg">
  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.FirstName.Visible" />
      {{ 'common.personal-information.first-name' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.FirstName.LabelText"
    />
  </div>
  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.LastName.Visible" />
      {{ 'common.personal-information.last-name' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.LastName.LabelText"
    />
  </div>
  <div style="clear: both"></div>

  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.MiddleInitial.Visible" />
      {{ 'common.personal-information.middle-initial' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.MiddleInitial.LabelText"
    />
  </div>
  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.Prefix.Visible" />
      {{ 'common.personal-information.prefix' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.Prefix.LabelText"
    />
  </div>
  <div style="clear: both"></div>

  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.Suffix.Visible" />
      {{ 'common.personal-information.suffix' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.Suffix.LabelText"
    />
  </div>

  <div class="col-sm-6 mct-flex mct-col mb-12">
    <label class="control-label">
      <input type="checkbox" [(ngModel)]="relatedProfileSettings.Title.Visible" />
      {{ 'common.personal-information.title' | translate | titlecase }}
    </label>
    <input
      type="text"
      placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
      [(ngModel)]="relatedProfileSettings.Title.LabelText"
    />
  </div>
  <div style="clear: both"></div>
</ng-container>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Address1.Visible" />
    {{ 'common.personal-information.address1' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Address1.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Address2.Visible" />
    {{ 'common.personal-information.address2' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Address2.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.City.Visible" />
    {{ 'common.personal-information.city' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.City.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.State.Visible" />
    {{ 'common.personal-information.state' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.State.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Zip.Visible" />
    {{ 'common.personal-information.zip' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Zip.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.ZipExt.Visible" />
    {{ 'common.personal-information.zipext' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.ZipExt.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.County.Visible" />
    {{ 'common.personal-information.county' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.County.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Country.Visible" />
    {{ 'common.personal-information.country' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Country.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.WorkPhone.Visible" />
    {{ 'common.personal-information.work-phone' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.WorkPhone.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.HomePhone.Visible" />
    {{ 'common.personal-information.home-phone' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.HomePhone.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.CellPhone.Visible" />
    {{ 'common.personal-information.cell-phone' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.CellPhone.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Ext.Visible" />
    {{ 'common.personal-information.ext' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Ext.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Fax.Visible" />
    {{ 'common.personal-information.fax' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Fax.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.Email.Visible" />
    {{ 'common.personal-information.email' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.Email.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.BillingContact.Visible" />
    {{ 'common.personal-information.billing-contact' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.BillingContact.LabelText"
  />
</div>
<div *ngIf="!isOrg" class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.ReceivesCommunication.Visible" />
    {{ 'common.personal-information.receives-communication' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.ReceivesCommunication.LabelText"
  />
</div>
<div *ngIf="isOrg" class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="relatedProfileSettings.RelationTypeToMember.Visible" />
    {{ 'common.personal-information.relation-type-to-member' | translate | titlecase }}
  </label>
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    [(ngModel)]="relatedProfileSettings.RelationTypeToMember.LabelText"
  />
</div>
<div style="clear: both"></div>
